import React from 'react';
import BroadcastArea from '../Sidebar/BroadcastArea.jsx';
import UserArea from '../Sidebar/UserArea.jsx';
import Footer from '../Sidebar/Footer.jsx';
import AdRow from '../Ads/AdRow.jsx';
import DefaultContentWrapper from './DefaultContentWrapper.jsx';
import FeedbackWidget from 'component/Feedback/FeedbackWidget';

// TODO remove all the template-items etc when we no longer use the template engine

const PageWithSidebars = ({children, removeAds, additionalBroadcastAreaItem, topView, wrapInContainer = true, hideMainContent}) =>
  <div>

    { !removeAds && <AdRow /> }
    


<div className="row wrapper">

      <div id="content-wrapper">

        { topView }

        { !hideMainContent &&
          <div className="row">
            <section className="template" id="content-area">
            	
              { wrapInContainer ? <DefaultContentWrapper>{children}</DefaultContentWrapper> : children }
            </section>

            <section className="template visible-sm-up sidebar" id="broadcast-area">
              <div className="row">

                { additionalBroadcastAreaItem &&
                  <div className="template-item col-md-12">
                    { additionalBroadcastAreaItem }
                  </div>
                }

                { !removeAds &&
                  <div className="template-item col-md-12">
                    <BroadcastArea />
                  </div>
                }
                <div className="template-item col-md-12">
                  <Footer />
                </div>
              </div>
            </section>
          </div>
        }
        </div>
        </div>
  </div>;

export default PageWithSidebars;



// WEBPACK FOOTER //
// ./src/component/Page/PageWithSidebars.jsx